import {useState} from "react";
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import { IconButton } from "@mui/material";
import CustomDialog from "../../../../../components/Dialog/DiaCompMedium";
import LongevityTextInfo from "./LongevityTextInfo";



export default function DiaInfoLong() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
    <Tooltip title="Info" placement="left">
        <IconButton onClick={handleOpen} size="small">
              <InfoIcon sx={{ '&:hover': { transform: 'scale(1.1)', color: 'quartiary.main', } }}/>
        </IconButton>   
    </Tooltip>

<CustomDialog open={open} onClose={handleClose}

    title="FOXO3 longevity variants / alleles"
    content = {<LongevityTextInfo />}
/>

</>
)}